import CenteredMapMarker from './CenteredMapMarker';

export default CenteredMapMarker;



// WEBPACK FOOTER //
// ./src/ondemand/components/CenteredMapMarker/index.js